module.exports = __webpack_public_path__ + "static/media/connect.04db7092.png";